export function resetStyleFromElement(element, className = 'custom-element') {
    if (element) {
        let removedClass = element
            .getAttribute('class')
            .replace(new RegExp('(\\s|^)'.concat(className, '(\\s|$)'), 'g'), '$2');
        element.setAttribute('class', removedClass);
    }
}
